import { ismain } from "./index";

/**
 * 非管理员禁用浏览器开发者工具（Rock 2026-09-16 要求）。
 *
 * ⚠️ 必须明确的边界：这是**提高门槛**，不是安全边界。
 * 前端代码运行在用户自己的浏览器里，绕过方式很多：从菜单而非 F12 打开、
 * 禁用 JavaScript、用 curl/Postman 直接打接口、改本地 JS。
 * 因此真正的防线只能在后端——不该给商户的数据就不要下发。
 * 本模块的作用是让普通商户不会顺手按 F12 翻看请求与响应。
 *
 * 管理员（ismain=true）不受限制，否则运维排障会被自己挡住。
 */

const isTargetUser = (): boolean => {
  try {
    // 未登录时不拦：登录页本身没有敏感数据，拦了反而妨碍排查
    return !ismain();
  } catch {
    return false;
  }
};

/** F12 / Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C / Ctrl+U(查看源码) */
const onKeyDown = (e: KeyboardEvent) => {
  const k = e.key;
  const upper = typeof k === "string" ? k.toUpperCase() : "";
  const hit =
    k === "F12" ||
    ((e.ctrlKey || e.metaKey) && e.shiftKey && ["I", "J", "C"].includes(upper)) ||
    ((e.ctrlKey || e.metaKey) && upper === "U");
  if (hit) {
    e.preventDefault();
    e.stopPropagation();
  }
};

const onContextMenu = (e: MouseEvent) => {
  e.preventDefault();
};

let started = false;

/**
 * 启用防护。幂等：重复调用只会生效一次。
 * 返回一个清理函数，供 React 卸载时解绑（避免热更新下重复挂监听）。
 */
export const setupDevtoolsGuard = (): (() => void) => {
  if (started || typeof window === "undefined") {
    return () => undefined;
  }
  if (!isTargetUser()) {
    return () => undefined;
  }
  started = true;

  window.addEventListener("keydown", onKeyDown, true);
  window.addEventListener("contextmenu", onContextMenu, true);

  return () => {
    window.removeEventListener("keydown", onKeyDown, true);
    window.removeEventListener("contextmenu", onContextMenu, true);
    started = false;
  };
};
